<template>
  <el-dialog width="80%" title="创建优惠券" :visible.sync="showgenStamps" :before-close="close">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="创建店铺券" name="first">
        <el-form ref="ruleForm" :rules="rules" :model="form" label-width="150px">
          <el-form-item label="券备注" prop="memo" style="width: 53%;">
            <el-input v-model="form.memo" placeholder="针对这次优惠券的备注"></el-input>
          </el-form-item>
          <el-form-item label="类型一" prop="used">
            <el-radio-group v-model="form.used">
              <el-radio :label="10">店铺全品券</el-radio>
              <el-radio :label="20">店铺专用券</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="类型二" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio :label="1">满减券</el-radio>
              <el-radio :label="3">立减券</el-radio>
              <el-radio :label="4">折扣券</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="面额" v-if="form.type == 1 " prop="withAmount" style="width: 50%;">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="form.withAmount"
                  type="number"
                  placeholder="满多少金额（元）"
                  style="width: 90%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">减</el-col>
            <el-col :span="11">
              <el-form-item prop="usedAmount">
                <el-input
                  v-model="form.usedAmount"
                  type="number"
                  placeholder="多少金额（元）"
                  style="width: 90%;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="面额" v-if="form.type == 3" prop="usedAmount" style="width: 53%;">
            <el-input v-model="form.usedAmount" type="number" placeholder="立减金额（元）"></el-input>
          </el-form-item>
          <el-form-item label="折扣" v-if="form.type == 4" prop="usedAmount" style="width: 80%;">
            <el-input
              v-model="form.usedAmount"
              type="number"
              max="100"
              min="0"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
              placeholder="%（折扣）"
            ></el-input>
          </el-form-item>
          <el-form-item label="自然天数" prop="validDays" style="width: 53%;">
            <el-input v-model="form.validDays" type="number" placeholder="自然天数"></el-input>
          </el-form-item>
          <el-form-item label="创建数量" prop="quota" style="width: 53%;">
            <el-input v-model="form.quota" type="number" placeholder="张数"></el-input>
          </el-form-item>
          <el-form-item label="每人限领" prop="peopleCount" style="width: 53%;">
            <el-select v-model="form.peopleCount" placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="(item , index) in 10"
                :key="index"
                :value="index + 1"
                :label="index + 1"
              />
              <el-option label="无限制" value="999"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在商品中心显示" prop="inActivity">
            <el-radio-group v-model="form.inActivity">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否直接领取" prop="avtivationStatus">
            <el-radio-group v-model="form.avtivationStatus">
              <el-radio :label="0">直接领取</el-radio>
              <el-radio :label="1">激活码激活</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="优惠券批次秘钥" prop="secret" style="width: 53%;">
            <el-input v-model="form.secret" disabled style="width: 20%;"></el-input>
            <span>
              <img src="@/assets/img/icon_shuaxini_01.png" @click="generateCode" class="shuxin" />
            </span>
          </el-form-item>
          <el-form-item label="关联店铺" v-if="form.used == 10 ">
            <el-button type="primary" size="medium" @click="store(form.used)">选择店铺</el-button>
            <el-table :data="goodsList" style="width: 80%">
              <el-table-column prop="name" label="店铺名称" />
            </el-table>
          </el-form-item>
          <el-form-item label="关联商品" v-if="form.used == 60 ||form.used == 20">
            <el-button type="primary" size="medium" @click="store(form.used)">选择商品</el-button>
            <el-table :data="goodsList" style="width: 80%">
              <el-table-column prop="spu_id" label="商品ID" />
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img class="imge" :src="scope.row.image_main" alt />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称" />
              <el-table-column prop="sta_name" label="商品分类" />
              <el-table-column prop="total_stock" label="库存" />
              <el-table-column prop="sku_price_sell" label="销售价" />
            </el-table>
          </el-form-item>
          <el-form-item>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit1('ruleForm')">确认</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="创建平台券" name="second">
        <el-form ref="ruleForm1" :rules="rules" :model="form" label-width="150px">
          <el-form-item label="券备注" prop="memo" style="width: 53%;">
            <el-input v-model="form.memo" placeholder="针对这次优惠券的备注"></el-input>
          </el-form-item>
          <el-form-item label="类型一" prop="used">
            <el-radio-group v-model="form.used">
              <el-radio :label="60">平台专用券</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="显示名称"
            v-if="form.used == 6 ||form.used == 60"
            prop="title"
            style="width: 53%;"
          >
            <el-input v-model="form.title" placeholder="名称，非必填项"></el-input>
          </el-form-item>
          <el-form-item label="类型二" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio :label="1">满减券</el-radio>
              <el-radio :label="3">立减券</el-radio>
              <el-radio :label="4">折扣券</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="面额" v-if="form.type == 1 " prop="withAmount" style="width: 50%;">
            <el-col :span="11">
              <el-form-item>
                <el-input
                  v-model="form.withAmount"
                  type="number"
                  placeholder="满多少金额（元）"
                  style="width: 90%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">减</el-col>
            <el-col :span="11">
              <el-form-item prop="usedAmount">
                <el-input
                  v-model="form.usedAmount"
                  type="number"
                  placeholder="多少金额（元）"
                  style="width: 90%;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="面额" v-if="form.type == 3" prop="usedAmount" style="width: 53%;">
            <el-input v-model="form.usedAmount" type="number" placeholder="立减金额（元）"></el-input>
          </el-form-item>
          <el-form-item label="折扣" v-if="form.type == 4" prop="usedAmount" style="width: 80%;">
            <el-input
              v-model="form.usedAmount"
              type="number"
              max="100"
              min="0"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
              placeholder="%（折扣）"
            ></el-input>
          </el-form-item>
          <el-form-item label="有效类型" prop="validType">
            <el-radio-group v-model="form.validType">
              <el-radio :label="2">自然天数</el-radio>
              <el-radio :label="1">固定天数</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="自然天数"
            v-if="form.validType == 2"
            prop="validDays"
            style="width: 53%;"
          >
            <el-input v-model="form.validDays" type="number" placeholder="自然天数"></el-input>
          </el-form-item>
          <el-form-item label="固定天数" v-if="form.validType == 1" prop="Time" style="width: 53%;">
            <el-date-picker
              v-model="form.Time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="创建数量" prop="quota" style="width: 53%;">
            <el-input v-model="form.quota" type="number" placeholder="张数"></el-input>
          </el-form-item>
          <el-form-item label="每人限领" prop="peopleCount" style="width: 53%;">
            <el-select v-model="form.peopleCount" placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="(item , index) in 10"
                :key="index"
                :value="index + 1"
                :label="index + 1"
              />
              <el-option label="无限制" value="999"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在商品中心显示" prop="inActivity">
            <el-radio-group v-model="form.inActivity">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否直接领取" prop="avtivationStatus">
            <el-radio-group v-model="form.avtivationStatus">
              <el-radio :label="0" v-if="this.form.used == 10 || this.form.used == 20">直接领取</el-radio>
              <el-radio :label="0" disabled v-if="this.form.used == 6 || this.form.used == 60">直接领取</el-radio>
              <el-radio :label="1">激活码激活</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="优惠券批次秘钥" prop="secret" style="width: 53%;">
            <el-input v-model="form.secret" disabled style="width: 20%;"></el-input>
            <span>
              <img src="@/assets/img/icon_shuaxini_01.png" @click="generateCode" class="shuxin" />
            </span>
          </el-form-item>
          <el-form-item label="关联商品" v-if="form.used == 60 ||form.used == 20">
            <el-button type="primary" size="medium" @click="store(form.used)">选择商品</el-button>
            <el-table :data="goodsList" style="width: 80%">
              <el-table-column prop="spu_id" label="商品ID" />
              <el-table-column label="商品图片">
                <template slot-scope="scope">
                  <img class="imge" :src="scope.row.image_main" alt />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="商品名称" />
              <el-table-column prop="sta_name" label="商品分类" />
              <el-table-column prop="total_stock" label="库存" />
              <el-table-column prop="sku_price_sell" label="销售价" />
            </el-table>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上传电子版确认函" prop="fileList" ref="uploadElement">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :auto-upload="false"
                  :file-list="fileList"
                  :limit="1"
                  list-type="picture"
                  :on-remove="handleRemove"
                  :on-change="(file, fileList) => handleChange(file)"
                >
                  <el-button
                    size="small"
                    type="primary"
                    v-show="this.form.fileUrls.length == 0"
                  >点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button size="small" type="primary" @click="xz()">模板下载</el-button>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="onSubmit1('ruleForm1')">确认</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <Store :show="showStore" :stores="stores" @close="closeStore" />
    <el-dialog
      title="创建优惠券确认"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <el-form :model="form">
        <el-form-item label="类型一：">
          <span v-if="form.used == 10">店铺全品券</span>
          <span v-if="form.used == 20">店铺专用券</span>
          <span v-if="form.used == 60">平台专用券</span>
        </el-form-item>
        <el-form-item label="类型二：">
          <span v-if="form.type == 1">满减券</span>
          <span v-if="form.type == 3">立减券</span>
          <span v-if="form.type == 4">折扣券</span>
        </el-form-item>
        <el-form-item label="面额：">
          <span v-if="form.type == 1">满{{form.withAmount}}减{{form.usedAmount}}</span>
          <span v-if="form.type == 3">立减{{form.usedAmount}}</span>
          <span v-if="form.type == 4">{{form.usedAmount}}%折扣</span>
        </el-form-item>
        <el-form-item label="有效期：" v-if="form.validType == 2">
          <span>{{form.validDays}}天</span>
        </el-form-item>
        <el-form-item label="有效期：" v-if="form.validType == 1">
          <span>{{form.Time[0]}}到{{form.Time[1]}}</span>
        </el-form-item>
        <el-form-item label="创建数量：">
          <span>{{form.quota}}张</span>
        </el-form-item>
        <el-form-item label="每人限领：">
          <span>{{form.peopleCount}}张</span>
        </el-form-item>
        <el-form-item label="是否在商品中显示：">
          <span v-if="form.inActivity == 0">否</span>
          <span v-if="form.inActivity == 1">是</span>
        </el-form-item>
        <el-form-item label="是否直接领取">
          <span v-if="form.avtivationStatus == 0">直接领取</span>
          <span v-if="form.avtivationStatus == 1">激活码激活</span>
        </el-form-item>
        <el-form-item label="优惠券批次秘钥：">
          <span>{{form.secret}}</span>
        </el-form-item>
        <el-form-item label="关联商品：">
          <span
            v-if="$store.multipleSelection&&$store.multipleSelection.length>0"
          >{{$store.multipleSelection.length}}个</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Store from "./couponSettingStore";
import { mapActions } from "vuex";
import { couponCreate, couponGenerateCode } from "@/api/couponManagement/couponSetting";
export default {
  props: ["show"],
  components: {
    Store,
  },
  data() {
    return {
      fileList: [],
      dialogVisible: false,
      activeName: "first",
      showgenStamps: false,
      showStore: false, //关联店铺
      stores: "", //关联店铺
      form: {
        backType: 1,
        used: 10,
        type: 1,
        validType: 2,
        inActivity: 0,
        memo: "",
        title: "",
        storePercent: "",
        withAmount: "",
        usedAmount: "",
        validDays: "",
        quota: "",
        peopleCount: "",
        secret: "",
        platformPercent: "",
        validStartTime: "",
        validEndTime: "",
        storeGoodsIds: [],
        fileUrls: [],
        relationType: "",
        Time: "", //时间
        storeName: "",
        companyName: "",
        avtivationStatus: 0,
      },
      rules: {
        memo: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" },
        ],
        used: [{ required: true, message: "请选择", trigger: "blur" }],
        storePercent: [{ required: true, message: "请输入", trigger: "blur" }],
        type: [{ required: true, message: "请输入", trigger: "blur" }],
        withAmount: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" },
        ],
        usedAmount: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" },
        ],
        validType: [{ required: true, message: "请输入", trigger: "blur" }],
        validDays: [{ required: true, message: "请输入", trigger: "blur" }],
        Time: [{ required: true, message: "请输入", trigger: "blur" }],
        quota: [
          { required: true, message: "请输入", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" },
        ],
        peopleCount: [{ required: true, message: "请输入", trigger: "blur" }],
        inActivity: [{ required: true, message: "请输入", trigger: "blur" }],
        avtivationStatus: [{ required: true, message: "请输入", trigger: "blur" }],
        secret: [{ required: true, message: "请输入", trigger: "blur" }],
        fileList: [{ required: true, message: "请上传", trigger: "blur" }],
      },
      goodsList: [],
    };
  },
  watch: {
    show() {
      this.showgenStamps = this.show;
      this.generateCode();
      this.$store.multipleSelection = [];
    },
  },
  methods: {
    ...mapActions({
      uploadFile: "commodity/uploadFile",
    }),
    handleChange(file) {
      this.rules.fileList = [];
      this.$refs["uploadElement"].clearValidate();
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.uploadFile(formdata).then((res) => {
        this.form.fileUrls.push(res.data.formdata_details[0].urls);
        console.log(this.form.fileUrls.length, "=======");
      });
    },
    handleRemove() {
      this.form.fileUrls = [];
      this.rules.fileList = [{ required: true, message: "请上传", trigger: "blur" }];
      this.$refs["uploadElement"].clearValidate();
    },
    close() {
      this.$emit("close");
    },
    closeStore() {
      this.showStore = false; //关联店铺
      if (this.form.used == 10) {
        this.goodsList = this.$store.multipleSelection;
      } else {
        this.goodsList = this.$store.goodsList;
      }
    },
    onSubmit1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (Number(this.form.withAmount) <= Number(this.form.usedAmount) && this.form.type == 1) {
            this.$message("已减金额不能大于满减金额");
          } else {
            if (this.form.used == 10) {
              this.relationType = 4;
              for (let i = 0; i < this.$store.multipleSelection.length; i++) {
                this.form.storeGoodsIds.push(this.$store.multipleSelection[i].shop_id);
                this.form.storeName = this.$store.multipleSelection[i].name;
              }
            } else if (this.form.used == 20) {
              this.relationType = 2;
              for (let i = 0; i < this.$store.multipleSelection.length; i++) {
                this.form.storeGoodsIds.push(this.$store.multipleSelection[i].spu_id);
              }
              this.form.storeName = this.$store.commoditys;
            } else {
              this.relationType = 2;
              for (let i = 0; i < this.$store.multipleSelection.length; i++) {
                this.form.storeGoodsIds.push(this.$store.multipleSelection[i].spu_id);
              }
              this.form.storeName = this.$store.commoditys;
            }
            if (this.$store.multipleSelection.length != 0) {
              this.dialogVisible = true;
            } else {
              this.$message("请关联商品或者店铺");
            }
          }
        }
      });
    },
    onSubmit() {
      if (this.form.validType == 1) {
        this.form.validStartTime = this.form.Time[0];
        this.form.validEndTime = this.form.Time[1];
      }
      let data = this.form;
      data.relationType = this.relationType;
      data.companyName = this.$store.getters.getUserInfo.company_name;
      console.log(data);
      couponCreate(data).then((res) => {
        console.log(res, "--------");
        this.resetForm("ruleForm");
        this.dialogVisible = false;
        this.form.withAmount = "";
        this.fileList = [];
        this.goodsList = [];
        this.form.Time = "";
        this.form.fileUrls = [];
        this.form.title = "";
        this.close();
      });
    },
    store(row) {
      this.showStore = true;
      this.stores = row;
      this.$store.multipleSelection = [];
      this.form.storeGoodsIds = [];
    }, // 关联店铺
    generateCode() {
      couponGenerateCode().then((res) => {
        this.form.secret = res.result;
        console.log(this.form.secret);
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClick() {
      this.form.used = 60;
      if (this.form.used == 6 || this.form.used == 60) {
        this.form.avtivationStatus = 1;
      } else {
        this.form.avtivationStatus = 0;
      }
    },
    // 下载
    xz() {
      let href = "http://coupon.sz-chaohui.cn/profile/upload/confirm-template.doc";
      window.open(href, "_blank");
    },
  },
};
</script>

<style scoped>
.tou {
  text-align: center;
  margin: 10px;
  font-size: 20px;
}
.queryMenu {
  text-align: center;
}
.shuxin {
  width: 20px;
  height: 20px;
}
.imge {
  width: 60px;
  height: 60px;
}
</style>
